import React from "react";
import { cn } from "../../lib/utils";

const FieldGroup = React.forwardRef(({ className, ...props }, ref) => (
  <div ref={ref} className={cn("flex flex-col gap-5", className)} {...props} />
));
FieldGroup.displayName = "FieldGroup";

const Field = React.forwardRef(({ className, ...props }, ref) => (
  <div ref={ref} className={cn("group/field flex flex-col gap-2", className)} {...props} />
));
Field.displayName = "Field";

const FieldLabel = React.forwardRef(({ className, ...props }, ref) => (
  <label ref={ref} className={cn("flex items-center gap-2 text-sm font-medium text-foreground [&_svg]:size-4 [&_svg]:text-muted-foreground", className)} {...props} />
));
FieldLabel.displayName = "FieldLabel";

const FieldDescription = React.forwardRef(({ className, ...props }, ref) => (
  <p ref={ref} className={cn("text-xs leading-relaxed text-muted-foreground", className)} {...props} />
));
FieldDescription.displayName = "FieldDescription";

const FieldError = React.forwardRef(({ className, ...props }, ref) => (
  <p ref={ref} className={cn("text-xs font-medium text-destructive", className)} {...props} />
));
FieldError.displayName = "FieldError";

export { Field, FieldDescription, FieldError, FieldGroup, FieldLabel };
